import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ENVIRONMENT } from '@interacta-shared/data-access-configuration';
import { toQuillTable } from '@interacta/data-access-post';
import { QuillTable } from '@interacta/util-post';
import { Observable, map } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TableInfoService {
    private http = inject(HttpClient);

    private readonly baseUrl = `${inject(ENVIRONMENT).apiBasePath.common}/internal/v2/communication/posts/data/tables`;

    getTableInfo(tableId: number): Observable<QuillTable> {
        return this.http
            .get<any>(`${this.baseUrl}/${tableId}`)
            .pipe(map(toQuillTable));
    }
}
